if (!customElements.get("s-main-wishlist")) {
  customElements.define(
    "s-main-wishlist",
    class SectionWishlist extends HTMLElement {
      connectedCallback() {
        this.loader = this.querySelector(".js-main-wishlist__loader");
        this.emptyText = this.querySelector(".js-main-wishlist__empty-text");
        this.loadingText = this.querySelector(".js-main-wishlist__loading-text");
        this.container = this.querySelector(".js-main-wishlist__products-grid");

        this.container?.addEventListener("click", this.handleRemoveClick);

        this.init();
      }

      disconnectedCallback() {
        this.container?.removeEventListener("click", this.handleRemoveClick);

        this.wishlistReadyUnsubscriber?.();
        this.wishlistUpdatedUnsubscriber?.();
        this.wishlistErrorUnsubscriber?.();
      }

      async init() {
        try {
          window.WishlistStore?.setConsent?.(true);

          const state = await window.WishlistStore?.refresh?.(true);

          await this.renderWishlist(state);

          this.subscribeToWishlistEvents();
        } catch (error) {
          console.error("Wishlist init error:", error);
          this.stopLoader();
          this.loadingText?.classList.add("is-hidden");
          this.emptyText?.classList.remove("is-hidden");
        }
      }

      subscribeToWishlistEvents() {
        this.wishlistReadyUnsubscriber = window.PubSub?.subscribe?.(
          "wishlist:ready",
          ({ state }) => {
            this.renderWishlist(state);
          }
        );

        this.wishlistUpdatedUnsubscriber = window.PubSub?.subscribe?.(
          "wishlist:updated",
          ({ state }) => {
            this.renderWishlist(state);
          }
        );

        this.wishlistErrorUnsubscriber = window.PubSub?.subscribe?.(
          "wishlist:error",
          (payload) => {
            console.error("Wishlist error:", payload);
            this.stopLoader();
            this.loadingText?.classList.add("is-hidden");
          }
        );
      }

      handleRemoveClick = async (event) => {
        const button = event.target.closest(".js-main-wishlist-remove");

        if (!button || !this.container?.contains(button)) return;

        event.preventDefault();
        event.stopPropagation();

        const productId = Number(button.dataset.productId);
        const variantId = Number(button.dataset.variantId);

        if (!productId || Number.isNaN(productId) || !variantId || Number.isNaN(variantId)) {
          console.error("[Wishlist] invalid remove payload", {
            productId,
            variantId,
          });
          return;
        }

        const tile = button.closest(".wishlist-product-tile");

        button.disabled = true;
        tile?.classList.add("is-removing");

        try {
          const handle = button.dataset.handle || "";

          if (!handle) {
            console.error("[Wishlist] missing product handle for remove", {
              productId,
              variantId,
            });

            button.disabled = false;
            tile?.classList.remove("is-removing");
            return;
          }

          await window.WishlistStore?.remove?.({
            id: productId,
            variantId,
            handle,
          });
        } catch (error) {
          console.error("[Wishlist] remove product error:", error);

          button.disabled = false;
          tile?.classList.remove("is-removing");
        }
      };

      async renderWishlist(state = window.WishlistStore?.getState?.() || {}) {
        if (!this.container) return;

        this.playLoader();

        try {
          const items = state.items || [];

          document.body.classList.add("wishlist-ready");
          this.loadingText?.classList.add("is-hidden");

          if (!items.length) {
            this.container.innerHTML = "";
            this.emptyText?.classList.remove("is-hidden");
            return;
          }

          const compiledItems = await Promise.all(
            items.map((item) => window.WishlistStore?.ensureProductCardHtml?.(item))
          );

          const validItems = compiledItems.filter(Boolean);

          this.container.innerHTML = validItems.join("");
          this.emptyText?.classList.toggle("is-hidden", validItems.length > 0);
        } catch (error) {
          console.error("Main wishlist render error:", error);

          this.container.innerHTML = "";
          this.emptyText?.classList.remove("is-hidden");
        } finally {
          this.stopLoader();
        }
      }

      playLoader() {
        this.loader?.classList.add("is-loading");
      }

      stopLoader() {
        this.loader?.classList.remove("is-loading");
      }
    }
  );
}